import { Skeleton } from "@timeghost/ui/shadcn/skeleton";
import type { JSX } from "react";

/** Skeleton for project Report chart + users (budget strip can stay live). */
export default function ProjectReportLoader({ showToolbar = false }: { readonly showToolbar?: boolean }): JSX.Element {
	return (
		<div aria-busy aria-label="Loading" className="flex flex-col gap-4">
			{showToolbar ? (
				<>
					<section className="grid gap-3 rounded-xl border border-border p-4 sm:grid-cols-3">
						{Array.from({ length: 3 }, (_, index) => (
							<div className="space-y-2" key={`stat-${index}`}>
								<Skeleton className="h-3 w-20" />
								<Skeleton className="h-6 w-24" />
							</div>
						))}
					</section>
					<div className="flex flex-wrap items-center gap-2">
						<Skeleton className="h-9 w-56 rounded-md" />
						<Skeleton className="h-4 w-28" />
					</div>
				</>
			) : null}
			<section className="min-h-[16rem] rounded-xl border border-border p-2">
				<Skeleton className="h-64 w-full rounded-lg" />
			</section>
			<section className="overflow-hidden rounded-xl border border-border">
				<div className="border-border border-b px-3 py-2">
					<Skeleton className="h-4 w-24" />
				</div>
				<div className="space-y-2 p-3">
					{Array.from({ length: 4 }, (_, index) => (
						<Skeleton className="h-10 w-full" key={`user-${index}`} />
					))}
				</div>
			</section>
		</div>
	);
}
